import HttpConnector from '../http/HttpConnector'

//////////////////////////////////////////
// EXPORT ACTIONS
/////////////////////////////////////////
export default {
  async getUserInfo({ commit }) {
    try {
      const userInfo = await HttpConnector.getInstance().getSettings()
      commit('mUserInfo', userInfo.data)
      return userInfo
    } catch (e) {
      return null
    }
  },
  async getTemplate({ commit }, id = null) {
    const result = await HttpConnector.getInstance().getTemplates(id)
    commit('mLoadTemplate', result)
  },
  async saveTemplate({ commit }, data) {
    const result = await HttpConnector.getInstance().saveTemplate(data)
    commit('mAddTemplate', result)
    commit('mSetCurrentTemplate', result.id)

    return result
  },
  setCurrentTemplate({ commit }, id) {
    commit('mSetCurrentTemplate', id)
  },
  async updateTemplate({ commit }, data) {
    const result = await HttpConnector.getInstance().updateTemplate(data)
    commit('mUpdateTemplate', data)
    return result
  },
  async deleteTemplate({ commit }, data) {
    const result = await HttpConnector.getInstance().deleteTemplate(data)
    commit('mRemoveTemplate', data)
    return result
  },
  updateCurrentFormat: ({ commit }, selectedFormat) => {
    commit('mUpdateCurrentFormat', selectedFormat)
  },
  updateFontFormat: ({ commit }, fontFormat) => {
    commit('mUpdateFont', fontFormat)
  },
  updateCurrentColor: ({ commit }, color) => {
    commit('mUpdateColor', color)
  },
  async getUnsplash(context, { search, page }) {
    const p = context.getters.getLimitations.onlineSearchImageLimit === -1 ? page : 1
    const result = await HttpConnector.getInstance().getUnsplahPictures(search, p)
    return result
  },
  updateSaveLocal: ({ commit }, value) => {
    commit('mUpdateSaveLocal', value)
  },
  updateOpenedMode: ({ commit }, value) => commit('mUpdateOpenedMode', value),
  updateRestrictedSize: ({ commit }, value) => commit('mRestrictedSize', value),
  updateUpgradeEvent: ({ commit }, value) => commit('mUpdateUpgradeEvent', value),
  updateDomain: ({ commit }, value) => commit('mUpdateDomain', value),
  updateCloseButton: ({ commit }, value) => commit('mUpdateCloseButton', value),
  updateSaveMenuList: ({ commit }, value) => commit('mUpdateSaveMenuList', value)
}



// WEBPACK FOOTER //
// ./src/model/store/actions.js